import {
  managementModalStyle,
  StyledModal,
} from "pages/PatientOverview/styles";
import { Box, Grid } from "@mui/material";
import { icons } from "constants/icons";
import React from "react";
import { formatName } from "../../pages/ClinicAdmin/components/Management/common/functions";

type Props = {
  isEnabled: boolean;
  setIsEnabled: any;
  user: any;
};

export const UserDetailsModal = ({ isEnabled, setIsEnabled, user }: Props) => {
  return (
    <StyledModal
      aria-labelledby="unstyled-modal-title"
      aria-describedby="unstyled-modal-description"
      open={isEnabled}
    >
      <Box sx={managementModalStyle}>
        <Grid container mt={1} mb={1}>
          <Grid item xs={11} />
          <Grid item xs={1}>
            <img
              src={icons.modalClose}
              alt="close"
              style={{ cursor: "pointer" }}
              onClick={() => {
                setIsEnabled(false);
              }}
              aria-hidden="true"
            />
          </Grid>
        </Grid>
        <>
          {user?.imageUrl && (
            <div style={{ width: "100%", textAlign: "left" }}>
              <div className="w-[60px] h-[60px] rounded-full overflow-hidden">
                <img
                  alt="user image"
                  className="object-cover min-w-full min-h-full"
                  src={user.imageUrl}
                />
              </div>
            </div>
          )}
          <div style={{ width: "100%", textAlign: "left" }}>
            <p
              style={{
                fontSize: "22px",
                wordWrap: "break-word",
                wordBreak: "break-all",
                whiteSpace: "pre-wrap",
                fontWeight: "800",
                maxWidth: "100%",
              }}
            >
              {user?.profileInfo?.firstName} {user?.profileInfo?.lastName}
            </p>
            <div>
              <p
                style={{
                  color: "#5C5D68",
                  fontSize: "14px",
                }}
              >
                {user.role?.map(formatName).join(", ")}
              </p>
            </div>

            <div style={{ marginTop: "24px" }}>
              <p style={{ fontSize: "14px", fontWeight: "800" }}>Email</p>
              <p style={{ color: "#5C5D68" }}>
                {user.profileInfo?.email || ""}
              </p>
            </div>
            <div>
              <p style={{ fontSize: "14px", fontWeight: "800" }}>Location</p>
              <p style={{ color: "#5C5D68" }}>
                {user.profileInfo?.address || user.profileInfo?.city || "N/A"}
              </p>
            </div>
            <div>
              <p style={{ fontSize: "14px", fontWeight: "800" }}>License</p>
              <p style={{ color: "#5C5D68" }}>
                {user.profileInfo?.license || "N/A"}
              </p>
              <div>
                <p style={{ fontSize: "14px", fontWeight: "800" }}>Phone</p>
                <p style={{ color: "#5C5D68" }}>
                  {user.profileInfo?.phoneNumber || "N/A"}
                </p>
              </div>
            </div>
          </div>
        </>
      </Box>
    </StyledModal>
  );
};
